import React, { useEffect, useState } from "react";
import ProductInfo from "../ProductInfo/ProductInfo";
import './FactoryProduct.css'
import logoBanner from '../../Assests/4f71dc90cc29b4ed69de0636891985f083fdf283.png'
import { urlApiServer, urlApiServerImage } from "../../Config/Config";
import arrow from '../../Assests/left-arrow.png'


function FactoryProduct(props) {
    const [selectProduct, setSelectProduct] = useState(false);
    const [infoProduct, setInfoProduct] = useState();
    const [filteredProducts, setFilteredProducts] = useState([]);

    const urlGetProducts = `${urlApiServer}productos?populate=*`

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetProducts, requestOptions)
                    .then(response => response.json())
                    .then(contactResponse => {
                        // Asegurar que siempre sea un array
                        if (Array.isArray(contactResponse.data)) {
                            // Filter products that belong to the current factory
                            const filtered = contactResponse.data.filter(product =>
                                product.fabricas && product.fabricas.some(fabrica => fabrica.id === props.factoryInfo.id)
                            );
                            setFilteredProducts(filtered.reverse());
                        } else {
                            setFilteredProducts([]);
                        }
                    });
            } catch (error) {
                console.log('el backend esta temporalmente desactivado');
                setFilteredProducts([]); // Asegurar que sea un array vacío en caso de error
            }
        })();
    }, [urlGetProducts, props.factoryInfo.id]);

    function handleProduct(product) {
        setSelectProduct(true);
        setInfoProduct(product);
    }

    function handleCloseFactoryProduct() {
        // Aquí necesitamos acceder a la función que cambia el estado en el componente padre
        // Como estamos pasando la prop 'onClose' desde Articles, la usamos así:
        if (props.onClose) {
            props.onClose();
        }
    }

    return (
        <div>
            {(selectProduct === false) ? (
                <>
                    <div className="bannerContainer" style={{ backgroundImage: `url(${urlApiServerImage + props.factoryInfo.portada?.url})`, height: '42vh' }}>
                        <img src={logoBanner} alt="logoBanner" className="logoBanner" />
                    </div>
                    <img src={arrow} alt="arrow" className="arrowBack" onClick={handleCloseFactoryProduct} />
                    <p className="titleFactoryProduct">{props.factoryInfo.titulo}</p>
                    <div className="factoryProductsContainer">
                        <div className="productGrid">
                            {filteredProducts.map(item => (
                                <div key={item.id} className="productCard" onClick={() => handleProduct(item)}>
                                    <img src={urlApiServerImage + item.Imagenes[0].url} alt={item.Nombre} className="productImage" />
                                    <p className="productTitle">{item.Nombre}</p>
                                    <p className="productID">ID {item.id}</p>
                                    {item.Mostrar_Precio && <p className="productPrice">Desde $ {item.precio} USD</p>}
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            ) : (
                <ProductInfo
                    product={infoProduct}
                    products={filteredProducts}
                    background={urlApiServerImage + props.factoryInfo.portada?.url}
                    onClose={() => setSelectProduct(false)}
                />
            )}
        </div>
    )
}

export default FactoryProduct